import React, { Component } from 'react'
import { connect } from 'react-redux'

import '../../assets/css/tor-template-list.css'
import { DatePicker,Select,InputDecimal,DropDownMuti } from '../../components/core';
import $ from 'jquery'
import { SecureGateRoute, BreadCrumb, DetailBotLogModal } from '../../components';
import { searchReportAction, exportReportAction } from '../../redux/actions/SearchAction'
import SearchTablePage from '../../components/Search/SearchTablePage';
import {AppSettings } from '../../configs'
import { Storage } from "../../configs";
import {
    data_status,
} from '../../configs/datas'
import moment from 'moment'
import {msg} from '../../components/Notifications/MsgBox';
import ReactTooltip from 'react-tooltip'


class SearchScreen extends Component {
    constructor(props) {
        super(props)

        this.state = {
            serachConditionModel: {
                RRSNO_FROM: '',
                RRSNO_TO: '',
                VENDOR_NAME: '',
                PO_CONTRACT_NO: '',
                CREATE_PO_CONTRACT: '',
                HEADER_TEXT: '',
                GOOD_RECIPIENT: '',
                MUTI_STATUS: '',
                STATUS: '',
                REQUISITIONER: '',
                REFERENCE_NO: '',
                POSTING_DATE_FROM: '',
                POSTING_DATE_TO: '',
                INVOICE_DATE_FROM: '',
                INVOICE_DATE_TO: '',
                PURCH_GROUP:'',
                CREATE_BY:'',
                CREATE_DATE_FROM:moment(new Date(new Date().getFullYear(), new Date().getMonth()-3, new Date().getDay()+1,0,0)).format('DD/MM/YYYY') ,
                CREATE_DATE_TO:moment(new Date()).format('DD/MM/YYYY') ,
                EDIT_BY:'',
                EDIT_DATE_FROM:'',
                EDIT_DATE_TO:'',
                GR_DELIVERY_NOTE:'',
                GR_PLANT:'',
                DEPARTMENT: Storage.getUser().isAdmin == true ? '' : Storage.getUser().unitCode,
                ROLE_ID: Storage.getRole(),
                USER: Storage.getUser().isAdmin == true ? '' : Storage.getUser().userName,
                IS_LOAD: false,
                IS_ADMIN: Storage.getUser().isAdmin,
                MOM_NO_FROM:'',
                MOM_NO_TO:'',
                MOM_EDIT_DATE_FROM:'',
                MOM_EDIT_DATE_TO:'',
                MOM_CREATE_BY:'',
                MOM_EDIT_BY:'',
                MOM_DEPARTMENT_CREATE_BY:''
            },
            q_rrsnumberFrom: '',
            q_rrsnumberTo: '',
            q_vendorname: '',
            q_po_contract_no: '',
            q_create_po_contract: '',
            q_header_text: '',
            q_goods_recipient: '',
            q_status: '',
            q_requisitioner: '',
            q_unit_requisitioner: '',
            q_procurement_method: '',
            q_doc_invoiceFrom: '',
            q_doc_invoiceTo: '',
            q_ref_invoice_no: '',
            q_purch_group:'',
            q_create_by:'',
            q_create_dateFrom:new Date(),
            q_create_dateTo:'',
            q_edit_by:'',
            q_edit_dateFrom:'',
            q_edit_dateTo:'',
            q_gr_delivery_note:'',
            q_gr_plant:'',
            isAdmin:Storage.getUser().isAdmin
        }

        //create date
        this.create_date_from_ref = React.createRef();
        this.create_date_to_ref = React.createRef();
        //Edit Date 
        this.edit_date_from_ref = React.createRef();
        this.edit_date_to_ref = React.createRef();

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDropdownMutiChange = this.handleDropdownMutiChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleExport = this.handleExport.bind(this);
        this.handleClear = this.handleClear.bind(this);
        
    }

    async componentDidMount() {
        let { serachConditionModel } = this.state;
        await this.props.searchReport(serachConditionModel);

        $(function () {
            window.onComponentDidMount()
        })
    }

    handleInputChange(event) {
        let { serachConditionModel } = this.state;
        const target = event.target
        let value = target.type === 'checkbox' ? target.checked : target.value
        const name = target.name

        //check date
        if (target.className) {
            if ((target.className.indexOf("js-datepicker") > -1 || target.className.indexOf("js-datepicker-all") > -1) && (value.toString()).indexOf("/") > 0) {
                let dateData = (value.toString()).split("/")
                let dateDataLength = dateData.length
                if (dateDataLength === 3) {
                    if (moment(value, 'DD/MM/YYYY').isValid()) {
                        value = moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY')
                    }
                }
            }
        }

        serachConditionModel[name] = value;

        this.setState({
            serachConditionModel: serachConditionModel
        })
    }

    handleDropdownMutiChange(event) {
        let { serachConditionModel } = this.state;
        let value=null
        if(event)
        {
            const target = event.target
            value = event
        }

        serachConditionModel['MUTI_STATUS'] = value

        console.log("handleDropdownMutiChange")
        console.log(serachConditionModel)
        this.setState({
            serachConditionModel: serachConditionModel
        })
    }

    async handleSearch(event) {
        let { serachConditionModel, isAdmin } = this.state;
        serachConditionModel.IS_LOAD=true;
        serachConditionModel.STATUS = null;
        let list_status=[];
        if(this.state.serachConditionModel.MUTI_STATUS)
        {
            this.state.serachConditionModel.MUTI_STATUS.map((item, key) =>
                list_status.push(item.value)
            );
        }
        serachConditionModel.STATUS = list_status.toString();

        event.preventDefault();
        await this.props.searchReport(serachConditionModel);
        if(this.props.resultSearch && this.props.resultSearch.length === 0)
        {
            msg.error("ไม่พบข้อมูล")
        }
        //await this.props.exportReport(serachConditionModel);
        
    }

    async handleExport(event) {
        let { serachConditionModel } = this.state;
        serachConditionModel.IS_LOAD=true;
        let list_status=[];
        if(this.state.serachConditionModel.MUTI_STATUS)
        {
            this.state.serachConditionModel.MUTI_STATUS.map((item, key) =>
                list_status.push(item.value)
            );
        }
        serachConditionModel.STATUS = list_status.toString();
        event.preventDefault();
         await this.props.exportReport(serachConditionModel);
         if (this.props.resultExport.isSuccess == true)
         {
            window.open( this.props.resultExport.returnMessage, '_blank', '');
         }
         else 
         {
            msg.error("ไม่พบข้อมูล");
         }
    }

    statusOptions = () => {
        return Promise.resolve([
            {
                value: "DRAF",
                label: "Draft"
            },
            {
                value: "WVER",
                label: "Waiting for Verification"
            },
            {
                value: "VERI",
                label: "Verifying"
            },
            {
                value: "REJT",
                label: "Rejected"
            },
            {
                value: "BCFM",
                label: "Automatically process"
            },
            {
                value: "MCFM",
                label: "Manually process"
            },
            {
                value: "MCOM",
                label: "Manual Completed"
            },
            {
                value: "BPRO",
                label: "BOT Processing"
            },
            {
                value: "BCOM",
                label: "BOT Completed"
            },
            {
                value: "BPCO",
                label: "BOT Partial Completed"
            },
            {
                value: "BINC",
                label: "BOT Incomplete"
            },
            {
                value: "WACCEPT",
                label: "Waiting for Accept"
            },
            {
                value: "ACCEPT",
                label: "Accept"
            },
            {
                value: "DECL",
                label: "Decline"
            },
            {
                value: "PCOM",
                label: "Print Complete"
            },
            {
                value: "COMPLETE",
                label: "Complete"
            }
        ]);
    }
    
    async handleClear(event) {

        event.preventDefault()
        await this.setState({
            serachConditionModel: {
                RRSNO_FROM: '',
                RRSNO_TO: '',
                VENDOR_NAME: '',
                PO_CONTRACT_NO: '',
                CREATE_PO_CONTRACT: '',
                HEADER_TEXT: '',
                GOOD_RECIPIENT: '',
                MUTI_STATUS: '',
                REQUISITIONER: '',
                REFERENCE_NO: '',
                POSTING_DATE_FROM: '',
                POSTING_DATE_TO: '',
                INVOICE_DATE_FROM: '',
                INVOICE_DATE_TO: '',
                PURCH_GROUP:'',
                CREATE_BY:'',
                CREATE_DATE_FROM: moment(new Date(new Date().getFullYear(), new Date().getMonth()-3, new Date().getDay()+1,0,0)).format('DD/MM/YYYY') ,
                CREATE_DATE_TO: moment(new Date()).format('DD/MM/YYYY') ,
                EDIT_BY:'',
                EDIT_DATE_FROM:'',
                EDIT_DATE_TO:'',
                GR_DELIVERY_NOTE:'',
                GR_PLANT:'',
                DEPARTMENT: Storage.getUser().isAdmin == true ? '' : Storage.getUser().unitCode,
                ROLE_ID: Storage.getRole(),
                USER: Storage.getUser().isAdmin == true ? '' : Storage.getUser().userName,
                IS_LOAD: false,
                IS_ADMIN: Storage.getUser().isAdmin,
            }
        })

        
        //create date
        this.create_date_from_ref.current.value = ''
        this.create_date_to_ref.current.value = ''
        
        window.$('#'+this.create_date_from_ref.current.props.id)
        // .datepicker({
        //     endDate: '+0d',
        //     todayHighlight: true,
        // })
        .datepicker(
            'setDate', moment(new Date(new Date().getFullYear(), new Date().getMonth()-3, new Date().getDay()+1,0,0)).format('DD/MM/YYYY')
        );

        window.$('#'+this.create_date_to_ref.current.props.id)
        .datepicker({
            endDate: '+0d',
            todayHighlight: true,
        })
        .datepicker(
            'setDate', moment(new Date()).format('DD/MM/YYYY')
        );

        //edit date
        this.edit_date_from_ref.current.value = ''
        this.edit_date_to_ref.current.value = ''

        window.$('#'+this.edit_date_from_ref.current.props.id)
        .datepicker({
            endDate: '+0d',
            todayHighlight: true,
        })
        .datepicker(
            'setDate', null
        );

        window.$('#'+this.edit_date_to_ref.current.props.id)
        .datepicker({
            endDate: '+0d',
            todayHighlight: true,
        })
        .datepicker(
            'setDate', null
        );

        let { serachConditionModel } = this.state;
        await this.props.searchReport(serachConditionModel);

    }

    render() {
        const {serachConditionModel} = this.state;

        return (
            <div className="tor tor-template-list">
                <SecureGateRoute/>
                <div id="main-content">
                    <div className="page-body">
                        <BreadCrumb breadcrumb={[
                            {name:'RRS Home',url:AppSettings.defaultUrl},
                            {name:'Transaction Report',url:''}
                        ]}></BreadCrumb>

                        <div className="sp-page-header-panel row">
                            <div className="col-md-5 sp-page-header">
                                <h1 className="sp-page-header1">Transaction Report</h1>
                            </div>
                        </div>

                        <div className="sp-page-result-container">

                        <div className="row">
                            <div className="col-md-6">
                                <div className="rrs-detail-data">
                                    <label htmlFor="gr_delivery_note" className="rrs-label mb-0">สถานะเอกสาร</label>
                                </div>
                                <div className="rrs-detail-data">
                                    <div className="form-group">
                                        {/* <Select
                                            id="MUTI_STATUS"
                                            name="MUTI_STATUS"
                                            className="form-control"
                                            placeholder=""
                                            value={serachConditionModel.MUTI_STATUS}
                                            onChange={this.handleInputChange}
                                        >
                                        <option value="">-- Select --</option>
                                        {data_status && data_status.map((item, index) => (
                                            <option key={index} value={item.code}>{item.description}</option>
                                        ))}
                                        </Select> */}

                                        <DropDownMuti
                                        loadOptions={this.statusOptions}
                                        id="MUTI_STATUS"
                                        value={this.state.serachConditionModel.MUTI_STATUS}
                                        className="form-control"
                                        placeholder=""
                                        onChange={this.handleDropdownMutiChange}
                                        // onChange={this.handleChange('runningNoSelectedOptions')}
                                        // value={this.state.runningNoSelectedOptions}
                                        >
                                        </DropDownMuti>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="rrs-detail-data">
                                    <label htmlFor="gr_post_date" className="rrs-label mb-0">RRS Create Date</label>
                                </div>
                                <div className="row">
                                    <div className="col-md-1 text-right"><span style={{ fontSize: '1rem' }}>From: </span></div>
                                    <div className="col-md-5">
                                        <DatePicker
                                            name="CREATE_DATE_FROM"
                                            id="CREATE_DATE_FROM"
                                            placeholder="dd/mm/yyyy"
                                            data-date-format="dd/mm/yyyy"
                                            value={serachConditionModel.CREATE_DATE_FROM}
                                            onChange={this.handleInputChange}
                                            onBlur={this.handleInputChange}
                                            doctype={"*"}
                                            tagid="search.CREATE_DATE_FROM"
                                            readOnly={true}
                                            ref={this.create_date_from_ref}
                                        />
                                    </div>
                                    <div className="col-md-1 text-right"><span style={{ fontSize: '1rem' }}>To: </span></div>
                                    <div className="col-md-5">
                                        <DatePicker
                                            name="CREATE_DATE_TO"
                                            id="CREATE_DATE_TO"
                                            placeholder="dd/mm/yyyy"
                                            data-date-format="dd/mm/yyyy"
                                            value={serachConditionModel.CREATE_DATE_TO}
                                            onChange={this.handleInputChange}
                                            onBlur={this.handleInputChange}
                                            doctype={"*"}
                                            tagid="search.CREATE_DATE_TO"
                                            readOnly={true}
                                            ref={this.create_date_to_ref}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="rrs-detail-data">
                                    <label htmlFor="gr_delivery_note" className="rrs-label mb-0">PO/Contract</label>
                                </div>
                                <div className="rrs-detail-data">
                                    <div className="form-group">
                                        <InputDecimal
                                            type="text"
                                            id="PO_CONTRACT_NO"
                                            name="PO_CONTRACT_NO"
                                            className="form-control"
                                            placeholder="ข้อมูล Purchase / Contract Number"
                                            pattern="[0-9]*"
                                            inputMode="decimal"
                                            floatingPoint={0}
                                            maxLength="10"
                                            value={serachConditionModel.PO_CONTRACT_NO}
                                            onChange={this.handleInputChange}
                                        />
                                    </div>
                                </div>

                            </div>
                            <div className="col-md-6">
                            <div className="rrs-detail-data">
                                <label htmlFor="gr_post_date" className="rrs-label mb-0">Requisitioner</label>
                            </div>
                            <div className="rrs-detail-data">
                                <div className="form-group">
                                    <input
                                        type="text"
                                        id="REQUISITIONER"
                                        name="REQUISITIONER"
                                        className="form-control"
                                        maxLength="8"
                                        floatingPoint={0}
                                        placeholder="รหัสหน่วยงาน ตย. 80000636 หรือ พย.บรก."
                                        value={serachConditionModel.REQUISITIONER}
                                        onChange={this.handleInputChange}
                                    />
                                </div>
                            </div>

                        </div>
                        </div>

                        <div className="showhide-detail-button">
                            <a className="btn-showhide-detail header-item-info collapsed" data-toggle="collapse" href="#collapseItemInfo" role="button" aria-expanded="false" aria-controls="collapseItemInfo">
                                <i className="icon icon-circle-up" /><span> Advanced Search</span>
                            </a>
                        </div>

                        <div className="collapse" id="collapseItemInfo">
                            <div className="rrs-detail pt-4 pb-3 px-3 item-information search_ad">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="rrs-detail-data">
                                        <p style={{marginBottom:0}} ref={ref => this.docFrom = ref} data-tip='
                                                - หากระบุใน format ตัวเลข : ระบบจะค้นหาตามเลขที่เอกสารเริ่มต้น จนถึงสิ้นสุดตามที่กำหนด<br/>
                                                - หากระบุใน format RRS+ปี+ตัวเลข : ระบบจะตัด RRS+ปี ออก และใช้เลข 6 หลักสุดท้ายในการค้นหา
                                                '></p>
                                            <label htmlFor="gr_delivery_note" className="rrs-label mb-0">RRS Doc. No.</label>
                                            <div className="icon-info"
                                                onMouseOver={() => { ReactTooltip.show(this.docFrom) }}
                                                onMouseLeave={() => { ReactTooltip.hide(this.docFrom) }}></div>
                                            <ReactTooltip html={true} />
                                        </div>
                                                                                
                                        <div className="row">
                                            <div className="col-md-1 text-right"><span style={{ fontSize: '1rem' }}>From: </span></div>
                                            <div className="col-md-5">
                                                <input
                                                    type="text"
                                                    id="RRSNO_FROM"
                                                    name="RRSNO_FROM"
                                                    className="form-control"
                                                    placeholder="เลขที่เริ่มต้น"
                                                    maxLength="13"
                                                    value={serachConditionModel.RRSNO_FROM}
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>
                                            <div className="col-md-1 text-right"><span style={{ fontSize: '1rem' }}>To: </span></div>
                                            <div className="col-md-5">
                                                <input
                                                    type="text"
                                                    id="RRSNO_TO"
                                                    name="RRSNO_TO"
                                                    className="form-control"
                                                    placeholder="เลขที่สิ้นสุด"
                                                    maxLength="13"
                                                    value={serachConditionModel.RRSNO_TO}
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                    <div className="rrs-detail-data">
                                        <label htmlFor="gr_post_date" className="rrs-label mb-0">RRS Edit Date</label>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-1 text-right"><span style={{ fontSize: '1rem' }}>From: </span></div>
                                        <div className="col-md-5">
                                            <DatePicker
                                                name="EDIT_DATE_FROM"
                                                id="EDIT_DATE_FROM"
                                                placeholder="dd/mm/yyyy"
                                                data-date-format="dd/mm/yyyy"
                                                value={serachConditionModel.EDIT_DATE_FROM}
                                                onChange={this.handleInputChange}
                                                onBlur={this.handleInputChange}
                                                doctype={"*"}
                                                tagid="search.EDIT_DATE_FROM"
                                                ref={this.edit_date_from_ref}
                                            />
                                        </div>
                                        <div className="col-md-1 text-right"><span style={{ fontSize: '1rem' }}>To: </span></div>
                                        <div className="col-md-5">
                                            <DatePicker
                                                name="EDIT_DATE_TO"
                                                id="EDIT_DATE_TO"
                                                placeholder="dd/mm/yyyy"
                                                data-date-format="dd/mm/yyyy"
                                                value={serachConditionModel.EDIT_DATE_TO}
                                                onChange={this.handleInputChange}
                                                onBlur={this.handleInputChange}
                                                doctype={"*"}
                                                tagid="search.EDIT_DATE_TO"
                                                ref={this.edit_date_to_ref}
                                            />
                                        </div>
                                    </div>
                                </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="rrs-detail-data">
                                            <label htmlFor="gr_delivery_note" className="rrs-label mb-0">RRS Create By</label>
                                        </div>
                                        <div className="rrs-detail-data">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    id="CREATE_BY" 
                                                    name="CREATE_BY"
                                                    className="form-control"
                                                    placeholder="รหัสพนักงาน, ชื่อ - สกุล"
                                                    value={serachConditionModel.CREATE_BY}
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="rrs-detail-data">
                                            <label htmlFor="gr_delivery_note" className="rrs-label mb-0">RRS Edit By</label>
                                        </div>
                                        <div className="rrs-detail-data">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    id="EDIT_BY" 
                                                    name="EDIT_BY"
                                                    className="form-control"
                                                    placeholder="รหัสพนักงาน, ชื่อ - สกุล"
                                                    value={serachConditionModel.EDIT_BY}
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                        
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="rrs-detail-data">
                                        <p style={{marginBottom:0}} ref={ref => this.docFromMOM = ref} data-tip='
                                                - หากระบุใน format ตัวเลข : ระบบจะค้นหาตามเลขที่เอกสารเริ่มต้น จนถึงสิ้นสุดตามที่กำหนด<br/>
                                                - หากระบุใน format MOM+ปี+ตัวเลข : ระบบจะตัด MOM+ปี ออก และใช้เลข 6 หลักสุดท้ายในการค้นหา
                                                '></p>
                                            <label htmlFor="gr_delivery_note" className="rrs-label mb-0">MOM Doc. No.</label>
                                            <div className="icon-info"
                                                onMouseOver={() => { ReactTooltip.show(this.docFromMOM) }}
                                                onMouseLeave={() => { ReactTooltip.hide(this.docFromMOM) }}></div>
                                            <ReactTooltip html={true} />
                                        </div>
                                                                                
                                        <div className="row">
                                            <div className="col-md-1 text-right"><span style={{ fontSize: '1rem' }}>From: </span></div>
                                            <div className="col-md-5">
                                                <input
                                                    type="text"
                                                    id="MOM_NO_FROM"
                                                    name="MOM_NO_FROM"
                                                    className="form-control"
                                                    placeholder="เลขที่เริ่มต้น"
                                                    maxLength="13"
                                                    value={serachConditionModel.MOM_NO_FROM}
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>
                                            <div className="col-md-1 text-right"><span style={{ fontSize: '1rem' }}>To: </span></div>
                                            <div className="col-md-5">
                                                <input
                                                    type="text"
                                                    id="MOM_NO_TO"
                                                    name="MOM_NO_TO"
                                                    className="form-control"
                                                    placeholder="เลขที่สิ้นสุด"
                                                    maxLength="13"
                                                    value={serachConditionModel.MOM_NO_TO}
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                    <div className="rrs-detail-data">
                                        <label htmlFor="gr_post_date" className="rrs-label mb-0">MOM Edit Date</label>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-1 text-right"><span style={{ fontSize: '1rem' }}>From: </span></div>
                                        <div className="col-md-5">
                                            <DatePicker
                                                name="MOM_EDIT_DATE_FROM"
                                                id="MOM_EDIT_DATE_FROM"
                                                placeholder="dd/mm/yyyy"
                                                data-date-format="dd/mm/yyyy"
                                                value={serachConditionModel.MOM_EDIT_DATE_FROM}
                                                onChange={this.handleInputChange}
                                                onBlur={this.handleInputChange}
                                                doctype={"*"}
                                                tagid="search.MOM_EDIT_DATE_FROM"
                                                ref={this.mom_edit_date_from_ref}
                                            />
                                        </div>
                                        <div className="col-md-1 text-right"><span style={{ fontSize: '1rem' }}>To: </span></div>
                                        <div className="col-md-5">
                                            <DatePicker
                                                name="MOM_EDIT_DATE_TO"
                                                id="MOM_EDIT_DATE_TO"
                                                placeholder="dd/mm/yyyy"
                                                data-date-format="dd/mm/yyyy"
                                                value={serachConditionModel.MOM_EDIT_DATE_TO}
                                                onChange={this.handleInputChange}
                                                onBlur={this.handleInputChange}
                                                doctype={"*"}
                                                tagid="search.MOM_EDIT_DATE_TO"
                                                ref={this.mom_edit_date_to_ref}
                                            />
                                        </div>
                                    </div>
                                </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="rrs-detail-data">
                                            <label htmlFor="gr_delivery_note" className="rrs-label mb-0">MOM Create By</label>
                                        </div>
                                        <div className="rrs-detail-data">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    id="MOM_CREATE_BY" 
                                                    name="MOM_CREATE_BY"
                                                    className="form-control"
                                                    placeholder="รหัสพนักงาน, ชื่อ - สกุล"
                                                    value={serachConditionModel.MOM_CREATE_BY}
                                                    onChange={this.handleInputChange}
                                                    maxLength="50"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="rrs-detail-data">
                                            <label htmlFor="gr_delivery_note" className="rrs-label mb-0">MOM Edit By</label>
                                        </div>
                                        <div className="rrs-detail-data">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    id="MOM_EDIT_BY" 
                                                    name="MOM_EDIT_BY"
                                                    className="form-control"
                                                    placeholder="รหัสพนักงาน, ชื่อ - สกุล"
                                                    value={serachConditionModel.MOM_EDIT_BY}
                                                    onChange={this.handleInputChange}
                                                    maxLength="50"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                        
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="rrs-detail-data">
                                            <label htmlFor="gr_delivery_note" className="rrs-label mb-0">หน่วยงานผู้สร้าง MOM</label>
                                        </div>
                                        <div className="rrs-detail-data">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    id="MOM_DEPARTMENT_CREATE_BY" 
                                                    name="MOM_DEPARTMENT_CREATE_BY"
                                                    className="form-control"
                                                    placeholder="รหัสหน่วยงาน ตย. 80000636 หรือ พย.บรก."
                                                    value={serachConditionModel.MOM_DEPARTMENT_CREATE_BY}
                                                    onChange={this.handleInputChange}
                                                    maxLength="50"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                        

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="rrs-detail-data">
                                            <label htmlFor="gr_post_date" className="rrs-label mb-0">ผู้สร้าง PO/Contract</label>
                                        </div>
                                        <div className="rrs-detail-data">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    id="CREATE_PO_CONTRACT"
                                                    name="CREATE_PO_CONTRACT"
                                                    className="form-control"
                                                    placeholder="รหัสพนักงาน, ชื่อ - สกุล"
                                                    value={serachConditionModel.CREATE_PO_CONTRACT}
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-6">
                                        <div className="rrs-detail-data">
                                            <label htmlFor="gr_delivery_note" className="rrs-label mb-0">Purch. Group</label>
                                        </div>
                                        <div className="rrs-detail-data">
                                            <div className="form-group">
                                                <InputDecimal
                                                    type="text"
                                                    id="PURCH_GROUP"
                                                    name="PURCH_GROUP"
                                                    className="form-control"
                                                    pattern="[0-9]*"
                                                    inputMode="decimal"
                                                    maxLength="3"
                                                    floatingPoint={0}
                                                    placeholder="ข้อมูล Purch. Group ตย. 110"
                                                    value={serachConditionModel.PURCH_GROUP}
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="rrs-detail-data">
                                            <label htmlFor="gr_delivery_note" className="rrs-label mb-0">GR Header Text</label>
                                        </div>
                                        <div className="rrs-detail-data">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    id="HEADER_TEXT"
                                                    name="HEADER_TEXT"
                                                    className="form-control"
                                                    placeholder="รายละเอียด/งวดงาน"
                                                    maxLength="25"
                                                    value={serachConditionModel.HEADER_TEXT}
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-6">
                                        <div className="rrs-detail-data">
                                            <label htmlFor="q_goods_recipient" className="rrs-label mb-0">GR Delivery Note/Reference</label>
                                        </div>
                                        <div className="rrs-detail-data">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    id="GR_DELIVERY_NOTE"
                                                    name="GR_DELIVERY_NOTE"
                                                    className="form-control"
                                                    placeholder="เลขที่ใบส่งของ/เลขที่ใบแจ้งหนี้/ใบกำกับภาษี"
                                                    maxLength="16"
                                                    value={serachConditionModel.GR_DELIVERY_NOTE}
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <div className="row">
                                <div className="col-md-6">
                                        <div className="rrs-detail-data">
                                            <label htmlFor="q_goods_recipient" className="rrs-label mb-0">Goods Recipient</label>
                                        </div>
                                        <div className="rrs-detail-data">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    id="GOOD_RECIPIENT"
                                                    name="GOOD_RECIPIENT"
                                                    className="form-control"
                                                    placeholder="รหัสพนักงาน"
                                                    maxLength="12"
                                                    value={serachConditionModel.GOOD_RECIPIENT}
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>
                                        </div>

                                    </div><div className="col-md-6" style={{visibility:"hidden"}}>
                                        <div className="rrs-detail-data">
                                            <label htmlFor="q_goods_recipient" className="rrs-label mb-0">GR Plant</label>
                                        </div>
                                        <div className="rrs-detail-data">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    id="GR_PLANT"
                                                    name="GR_PLANT"
                                                    className="form-control"
                                                    placeholder=""
                                                    value={serachConditionModel.GR_PLANT}
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                           
                                <div className="row" style={{paddingBottom:12}}>
                                <div className="col-md-6">
                                    <div className="rrs-detail-data">
                                        <label htmlFor="gr_post_date" className="rrs-label mb-0">Invoice Date</label>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-1 text-right"><span style={{ fontSize: '1rem' }}>From: </span></div>
                                        <div className="col-md-5">
                                            <DatePicker
                                                name="INVOICE_DATE_FROM"
                                                id="INVOICE_DATE_FROM"
                                                placeholder="dd/mm/yyyy"
                                                data-date-format="dd/mm/yyyy"
                                                value={serachConditionModel.INVOICE_DATE_FROM}
                                                onChange={this.handleInputChange}
                                                onBlur={this.handleInputChange}
                                                doctype={"*"}
                                                tagid="search.INVOICE_DATE_FROM"
                                            />
                                        </div>
                                        <div className="col-md-1 text-right"><span style={{ fontSize: '1rem' }}>To: </span></div>
                                        <div className="col-md-5">
                                            <DatePicker
                                                name="INVOICE_DATE_TO"
                                                id="INVOICE_DATE_TO"
                                                placeholder="dd/mm/yyyy"
                                                data-date-format="dd/mm/yyyy"
                                                value={serachConditionModel.INVOICE_DATE_TO}
                                                onChange={this.handleInputChange}
                                                onBlur={this.handleInputChange}
                                                doctype={"*"}
                                                tagid="search.INVOICE_DATE_TO"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="rrs-detail-data">
                                        <label htmlFor="gr_post_date" className="rrs-label mb-0">IR Posting Date</label>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-1 text-right"><span style={{ fontSize: '1rem' }}>From: </span></div>
                                        <div className="col-md-5">
                                            <DatePicker
                                                name="POSTING_DATE_FROM"
                                                id="POSTING_DATE_FROM"
                                                placeholder="dd/mm/yyyy"
                                                data-date-format="dd/mm/yyyy"
                                                value={serachConditionModel.POSTING_DATE_FROM}
                                                onChange={this.handleInputChange}
                                                onBlur={this.handleInputChange}
                                                doctype={"*"}
                                                tagid="search.POSTING_DATE_FROM"
                                            />
                                        </div>
                                        <div className="col-md-1 text-right"><span style={{ fontSize: '1rem' }}>To: </span></div>
                                        <div className="col-md-5">
                                            <DatePicker
                                                name="POSTING_DATE_TO"
                                                id="POSTING_DATE_TO"
                                                placeholder="dd/mm/yyyy"
                                                data-date-format="dd/mm/yyyy"
                                                value={serachConditionModel.POSTING_DATE_TO}
                                                onChange={this.handleInputChange}
                                                onBlur={this.handleInputChange}
                                                doctype={"*"}
                                                tagid="search.POSTING_DATE_TO"
                                            />
                                        </div>
                                    </div>

                                </div>
                                
                            </div>

                                <div className="row" style={{paddingBottom:12}}>
                                <div className="col-md-6">
                                        <div className="rrs-detail-data">
                                            <label htmlFor="gr_post_date" className="rrs-label mb-0">Vendor Name</label>
                                        </div>
                                        <div className="rrs-detail-data">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    id="VENDOR_NAME"
                                                    name="VENDOR_NAME"
                                                    className="form-control"
                                                    placeholder="รหัส, ชื่อ"
                                                    value={serachConditionModel.VENDOR_NAME}
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                <div className="col-md-6">
                                    <div className="rrs-detail-data">
                                        <label htmlFor="gr_delivery_note" className="rrs-label mb-0">IR Reference</label>
                                    </div>
                                    <div className="rrs-detail-data">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                id="REFERENCE_NO"
                                                name="REFERENCE_NO"
                                                className="form-control"
                                                maxLength="16"
                                                placeholder="เลขที่ใบส่งของ/เลขที่ใบแจ้งหนี้/ใบกำกับภาษี"
                                                value={serachConditionModel.REFERENCE_NO}
                                                onChange={this.handleInputChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                            
                            </div>
                            
                            </div>
                        </div>

                            <div className="rrs-detail2">
                                <div className="rrs-form-group-search">
                                    <div className="row justify-content-center mx-0">
                                    <div className="col-md-4"/>
                                        <div className="col-md-4">
                                            <a onClick={this.handleSearch} style={{ cursor: 'pointer' }}>
                                                <i className="icon btn-order-search"  />
                                            </a>
                                            <a onClick={this.handleClear} style={{ cursor: 'pointer',marginLeft:10,marginRight:10 }}> 
                                                <i className="icon btn-order-clear"  />
                                            </a>
                                        </div>
                                        <div className="col-md-4" style={{textAlign:"right"}}>
                                            <a onClick={this.handleExport} style={{ cursor: 'pointer' }}>
                                                <i className="icon btn-order-excel"  />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br></br>
                            <div className="rrs-detail2">
                                <div className="sp-table-container">
                                    <div className="row no-gutters sp-table-content">
                                        <SearchTablePage
                                            tablesearch={this.props.resultSearch}
                                            isAdmin={this.state.isAdmin}
                                            {...this.props} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <DetailBotLogModal />
                    </div>
                </div>
            </div >
        )
    }
}

const mapStateToProps = state => {
    const { SearchRedux } = state
    return {
        resultSearch: SearchRedux.resultSearch,
        resultExport: SearchRedux.resultExport,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        searchReport: (serachCondition) => dispatch(searchReportAction(serachCondition)),
        exportReport: (serachCondition) => dispatch(exportReportAction(serachCondition))
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SearchScreen);